export const KeywordData = [
  { value: "Assertion", label: "Assertion" },
  { value: "Alert", label: "Alert" },
  { value: "Button", label: "Button" },
  { value: "Check Box", label: "Check Box" },
  { value: "Clipboard", label: "Clipboard" },
  { value: "DropDown", label: "DropDown" },
  { value: "EditBox", label: "EditBox" },
  { value: "File", label: "File" },
  { value: "File Upload", label: "File Upload" },
  { value: "Inline", label: "Inline" },
  { value: "Link", label: "Link" },
  { value: "Radio Button", label: "Radio Button" },
  { value: "SVGElement", label: "SVGElement" },
  // { value: "Tab", label: "Tab" },
  { value: "TextArea", label: "TextArea" },
  { value: "Url", label: "Url" },
  { value: "Send", label: "Send" },
  { value: "Script", label: "Script" },
  { value: "Window", label: "Window" },
  { value: "TestCase", label: "Test Case" },
  { value: "mobile", label: "Mobile" },
  { value: "Mouse", label: "Mouse" },
  { value: "Api", label: "API" },
  { value: "conditionalLogic", label: "Conditional & Looping Logic" },
  { value: "onscreen", label: "onscreen" },
  { value: "mobileSensors", label: "Mobile Sensors" },
  { value: "mobilePermission", label: "Mobile Permission" },
  { value: "Keyboard", label: "Keyboard" },
  { value: "Browser", label: "Browser" },
  { value: "visualAnalysis", label: "Visual Analysis" },
];

export const TestDataOptions = [
  { value: "AsRecorded", label: "As Recorded" },
  { value: "UseVariableFromTheScenario", label: "Data Dependence-This Scenario" },
  { value: "DependentonOtherTestScenario", label: "Data Dependence-Other Scenario" },
  { value: "FromApi", label: "From Api" },
  { value: "FromDB", label: "From DB" },
  { value: "FromEmail", label: "From Email" },
  { value: "FromEmailDigits", label: "From Email Digits" },
  { value: "FromFile", label: "From File" },
  { value: "FromSMS", label: "From SMS" },
  { value: "FromSMSDigits", label: "From SMS Digits" },
  { value: "FromReferenceFile", label: "From TestData" },
  { value: "GenData", label: "Generate Data" },
  { value: "GoogleSheet", label: "Google Sheet" },
  { value: "LastRun", label: "Last Run" },
  { value: "Regex", label: "Regex" },
  { value: "SendEmail", label: "Send Email" },
  // { value: "SameRow", label: "On Same Row as Test Data" },
  // { value: "SameRowElement", label: "On Same Row as Previous Element" },
  // { value: "Script", label: "Script" }
];

export const AssertionOptions = [
  { value: "ChangeTestData", label: "Change Text" },
  { value: "Date", label: "Date" },
  { value: "DynamicText", label: "Dynamic Text" },
  { value: "FromEmail", label: "From Email" },
  { value: "InApi", label: "In Api" },
  { value: "DB", label: "In DB" },
  { value: "InDownloadedFile", label: "In Downloaded Files" },
  { value: "InFile", label: "In File" },
  { value: "InGoogleSheet", label: "In Google Sheet" },
  { value: "InRefrenceFile", label: "In TestData" },
  { value: "OnScreen", label: "On Screen" },
  { value: "UseVariableFromTheScenario", label: "Data Dependence-This Scenario" },
  { value: "DependentonOtherTestScenario", label: "Data Dependence-Other Scenario" },
  { value: "Regex", label: "Regex" },
  { value: "InStreamedFile", label: "In Streamed File" },
];

export const AssertTextOptions = [
  { value: "validatePartial", label: "Contains" },
  { value: "validateExact", label: "Exact" },
];

export const AppPermission = [
  { value: "enable", label: "Enable" },
  { value: "disable", label: "Disable" },
  { value: "check", label: "check" },
];

export const AssertSubOptions = [
  { value: "validateChecked", label: "Checked" },
  { value: "validateCount", label: "Count" },
  // { value: "validatePartial", label: "Contains" },
  // { value: "validateExact", label: "Exact" },
  { value: "validateEditable", label: "Editable" },
  { value: "validateFontFam", label: "Font Family" },
  { value: "validateFontSize", label: "Font Size" },
  { value: "validateHref", label: "Href" },
  { value: "validateMulti", label: "Multiple" },
  { value: "validatePageUrl", label: "Page URL" },
  { value: "validateActive", label: "Active" },
  { value: "validateSrc", label: "Image Src" },
  { value: "validatebuttonpresence", label: "Validate Button Presence" },
  { value: "validateLength", label: "Length" },
  { value: "validatedownloadedfilescount", label: "Downloaded Files Count" },
];

export const DropDownOptions = [
  { value: "ByText", label: "By Text" },
  { value: "ById", label: "By Index" },
  { value: "ByValue", label: "By Value" },
];

export const pressKeyCodeOptions = [
  { value: "HOME", label: "HOME" },
  { value: "BACK", label: "BACK" },
  { value: "APP_SWITCH", label: "APP_SWITCH" },
];

export const CheckBoxOptions = [
  { value: "ByText", label: "By Text" },
  { value: "ById", label: "By Id" },
  { value: "ByPath", label: "By Path" },
];

export const AssertionTargetOptions = [
  { value: "ChangeTestData", label: "Change Text" },
  { value: "Date", label: "Date" },
  { value: "DynamicText", label: "Dynamic Text" },
  { value: "FromEmail", label: "From Email" },
  { value: "InApi", label: "In Api" },
  { value: "DB", label: "In DB" },
  { value: "InDownloadedFile", label: "In Downloaded Files" },
  { value: "InFile", label: "In File" },
  { value: "InGoogleSheet", label: "In Google Sheet" },
  { value: "InRefrenceFile", label: "In TestData" },
  { value: "OnScreen", label: "On Screen" },
  { value: "UseVariableFromTheScenario", label: "Data Dependence-This Scenario" },
  { value: "DependentonOtherTestScenario", label: "Data Dependence-Other Scenario" },
  { value: "Regex", label: "Regex" },
  { value: "InStreamedFile", label: "In Streamed File" },
  { value: "LastRun", label: "Last Run" },
];

export const extractoption = [
  { label: "Don't process", value: "NULL" },
  { label: "Regex", value: "regex" },
  { label: "Sub-String", value: "SubString" },
];
export const scopeOptionList = [
  { value: "Multi Run", label: "Multi Run" },
  { value: "Multi Execution", label: "Multi Execution" },
  { value: "Single Run", label: "Single Run" },
];

export const selectUserOptions = [
  { label: "testuser1@test.com", value: "testuser1@test.com" },
  { label: "testuser2@test.com", value: "testuser2@test.com" },
  { label: "testuser3@test.com", value: "testuser3@test.com" },
];

export const DurationOptions = [
  { label: "Last Week", value: "last week" },
  { label: "Last 15 days", value: "last 15 days" },
  { label: "Last Month", value: "last month" },
];

export const RunTimeOptions = [
  { label: "00:00 - 01:00", value: "00:00 - 01:00" },
  { label: "01:00 - 02:00", value: "01:00 - 02:00" },
  { label: "02:00 - 03:00", value: "02:00 - 03:00" },
  { label: "03:00 - 04:00", value: "03:00 - 04:00" },
  { label: "04:00 - 05:00", value: "04:00 - 05:00" },
  { label: "05:00 - 06:00", value: "05:00 - 06:00" },
  { label: "06:00 - 07:00", value: "06:00 - 07:00" },
  { label: "07:00 - 08:00", value: "07:00 - 08:00" },
  { label: "08:00 - 09:00", value: "08:00 - 09:00" },
  { label: "09:00 - 10:00", value: "09:00 - 10:00" },
  { label: "10:00 - 11:00", value: "10:00 - 11:00" },
  { label: "11:00 - 12:00", value: "11:00 - 12:00" },
  { label: "12:00 - 13:00", value: "12:00 - 13:00" },
  { label: "13:00 - 14:00", value: "13:00 - 14:00" },
  { label: "14:00 - 15:00", value: "14:00 - 15:00" },
  { label: "15:00 - 16:00", value: "15:00 - 16:00" },
  { label: "16:00 - 17:00", value: "16:00 - 17:00" },
  { label: "17:00 - 18:00", value: "17:00 - 18:00" },
  { label: "18:00 - 19:00", value: "18:00 - 19:00" },
  { label: "19:00 - 20:00", value: "19:00 - 20:00" },
  { label: "20:00 - 21:00", value: "20:00 - 21:00" },
  { label: "21:00 - 22:00", value: "21:00 - 22:00" },
  { label: "22:00 - 23:00", value: "22:00 - 23:00" },
  { label: "23:00 - 00:00", value: "23:00 - 00:00" },
];

export const StatusOptions = [
  { label: "Must Fail", value: "Negative" },
  { label: "Must Pass", value: "Positive" },
  { label: "Optional", value: "Optional" },
  { label: "Disable", value: "Disable" },
];

export const StatusColors = {
  Negative: "#FDEAEA",
  Positive: "#FFFFFF",
  Optional: "#EAF2FD",
  Disable: "#F3F4F6",
};

export const GenDataOptions = [
  { label: "CHAR", value: "CHAR" },
  { label: "ALPHA", value: "ALPHA" },
  { label: "NUMBER", value: "NUMBER" },
  { label: "DECIMAL", value: "DECIMAL" },
  { label: "EMAIL", value: "EMAIL" },
  { label: "TODAY", value: "TODAY" },
];

export const WaitOptions = [
  { label: "Wait Before", value: "Before" },
  { label: "Wait After", value: "After" },
  { label: "Wait Till Found", value: "WaitTill" },
  { label: "Wait For All API", value: "WaitForAllApi" },
  { label: "Wait For Configured APIs", value: "WaitForConfiguredApis" },
  { label: "Check", value: "Check" },
];

export const ElementOptions = [
  { label: "Image", value: "IMG" },
  { label: "SVG", value: "SVG" },
  { label: "button", value: "Button" },
];
export const labelToKeyMap = {
  "Android UI Automator": "android_uiautomator",
  "Id Strategy": "id_strategy",
  "Object Identifier": "xpath",
};

export const MobilestrategyItems = [
  {
    label: "X-Path",
    value: "X-Path",
  },
  {
    label: "Android UI Automator",
    value: "AndroidUIAutomator",
  },
  {
    label: "Id Strategy",
    value: "IdStrategy",
  },
  {
    label: "Element Class",
    value: "ElementClass",
  },
  {
    label: "Element Bounds",
    value: "ElementBounds",
  },
];

export const strategyItems = [
  {
    label: "X-Path",
    value: "X-Path",
  },
  {
    label: "X-Y Coordinates",
    value: "XY",
  },
  {
    label: "Search on Page",
    value: "Search",
  },
  {
    label: "On same row as test data",
    value: "SameRow",
  },
  {
    label: "On same row as previous element",
    value: "SameRowElement",
  },
  {
    label: "PlaceHolder",
    value: "PlaceHolder",
  },
  {
    label: "ClassName",
    value: "ClassName",
  },
  {
    label: "Data-Test-Id",
    value: "DataTestId",
  },
  {
    label: "Attribute XPath",
    value: "AttributeXPath",
  },
  {
    label: "Closest Element",
    value: "ClosestElement",
  },
];

export const ADMIN_SIDEBAR_MENUS = [
  { id: "email", label: "Customer Email Property" },
  { id: "database", label: "Database Property" },
  { id: "integrations", label: "Integrations" },
  { id: "system", label: "System Property" },
  { id: "themes", label: "Themes" },
  { id: "oauth", label: "OAuth Credentials" },
  { id: "product", label: "New Product" },
  { id: "module", label: "New Module" },
  { id: "clearStorage", label: "Clear Storage" },
  { id: "companyUrl", label: "Company URL" },
  { id: "Companysettings", label: "Company Settings" },
  { id: "LLMSetup", label: "LLM Setup" },
  { id: "URlSetup", label: "Env URl Setup" },
  { id: "resolution", label: "Resolution Setup" },
  { id: "Execution", label: "Execution Setup" },
  { id: "designPrinciples", label: "Design Principles" },
  { id: "deviceList", label: "Device List" },
  { id: "framework", label: "Framework (Code Generation)" },
];
export const MOBILE_ONLY_KEYWORDS = ["mobile", "mobilePermission", "mobileSensors"];
export const COMMON_KEYWORDS = ["conditionalLogic", "Assertion", "visualAnalysis"];
